export const QUERY_KEY_USER_V1 = 'QUERY_KEY_USER_V1-v1'
export const QUERY_KEY_USER_V3 = 'QUERY_KEY_USER_V3'
export const QUERY_KEY_CURRENT_USER_V1 = 'QUERY_KEY_CURRENT_USER_V1'
export const QUERY_KEY_CURRENT_USER_V3 = 'QUERY_KEY_CURRENT_USER_V3'
export const QUERY_KEY_USER_PORTAL_STATUS = 'QUERY_KEY_USER_PORTAL_STATUS'
export const QUERY_KEY_USER_PRODUCT_STATUS = 'QUERY_KEY_USER_PRODUCT_STATUS'
export const QUERY_KEY_USER_PRODUCT_PROGRESS = 'QUERY_KEY_USER_PRODUCT_PROGRESS'
export const QUERY_KEY_USER_PRODUCT_BUNDLE_PROGRESS =
  'QUERY_KEY_USER_PRODUCT_BUNDLE_PROGRESS'
export const QUERY_KEY_USER_GROUPS = 'QUERY_KEY_USER_GROUPS'
export const QUERY_KEY_USER_NOTE = 'QUERY_KEY_USER_NOTE'
export const QUERY_KEY_USER_LIST = 'QUERY_KEY_USER_LIST'
export const QUERY_KEY_USER_PRODUCTS = 'QUERY_KEY_USER_PRODUCTS'

export const MUTATION_KEY_USER_PRODUCT = 'MUTATION_KEY_USER_PRODUCT'
export const MUTATION_KEY_USER_SCENARIO = 'MUTATION_KEY_USER_SCENARIO'
export const MUTATION_KEY_USER_ACTIVE = 'MUTATION_KEY_USER_ACTIVE'
export const MUTATION_KEY_USER_REPORT = 'MUTATION_KEY_USER_REPORT'
export const MUTATION_KEY_USER = 'MUTATION_KEY_USER'
export const MUTATION_KEY_USER_GROUPS_BATCH = 'MUTATION_KEY_USER_GROUPS_BATCH'
export const MUTATION_KEY_USER_GROUP_DELETE = 'MUTATION_KEY_USER_GROUP_DELETE'
export const MUTATION_KEY_USER_NOTE = 'MUTATION_KEY_USER_NOTE'
